var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2532_389)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 96,
    height: 96,
    rx: 48,
    fill: "black",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges",
    id: "eye-background"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2498 63.9998C73.2498 66.8993 70.8993 69.2498 67.9998 69.2498C65.1003 69.2498 62.7498 66.8993 62.7498 63.9998C62.7498 61.1003 65.1003 58.7498 67.9998 58.7498C70.8993 58.7498 73.2498 61.1003 73.2498 63.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 51.25C62.8521 51.25 58.8132 53.5513 55.9188 56.1109C53.0304 58.6653 51.2215 61.5269 50.4943 62.8019C50.0673 63.5505 50.0673 64.4495 50.4943 65.1981C51.2215 66.4731 53.0304 69.3347 55.9188 71.8891C58.8132 74.4487 62.8521 76.75 68 76.75C73.1478 76.75 77.1867 74.4487 80.0811 71.889C82.9695 69.3346 84.7783 66.4729 85.5055 65.198C85.9325 64.4494 85.9325 63.5504 85.5055 62.8018C84.7783 61.5268 82.9695 58.6653 80.0811 56.1109C77.1867 53.5512 73.1478 51.25 68 51.25ZM52.4488 63.9167C53.111 62.7557 54.7761 60.1251 57.4093 57.7964C60.0367 55.4729 63.5672 53.5 68 53.5C72.4327 53.5 75.9632 55.4729 78.5905 57.7963C81.2238 60.1251 82.8889 62.7556 83.5511 63.9165C83.5708 63.951 83.5758 63.9789 83.5758 63.9999C83.5758 64.0209 83.5708 64.0487 83.5511 64.0832C82.8889 65.2442 81.2238 67.8748 78.5905 70.2036C75.9632 72.5271 72.4327 74.5 68 74.5C63.5672 74.5 60.0367 72.5271 57.4093 70.2036C54.7761 67.8749 53.111 65.2443 52.4488 64.0833C52.4291 64.0488 52.4241 64.021 52.4241 64C52.4241 63.979 52.4291 63.9512 52.4488 63.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 17,
    width: 94,
    height: 94,
    rx: 47,
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2532_389",
    x: 0,
    y: 0,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2532_389"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2532_389",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.aeee9398.svg";
export { ForwardRef as ReactComponent };